import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.function.name";
import _get from "lodash/get";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  fragment getAboutSchema on Article {\n    __typename\n    categories {\n      name\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment getEditorSchema on Article {\n    __typename\n    assigningEditor {\n      id\n      name\n      link\n      avatarUrls(sizes: [SIZE_96]) {\n        size\n        url\n      }\n      alumniOf\n      affiliation\n      award\n      honorificSuffix\n      jobTitle\n      specialties\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment getAuthorSchema on Article {\n    __typename\n    authors {\n      id\n      name\n      link\n      avatarUrls(sizes: [SIZE_96]) {\n        size\n        url\n      }\n      alumniOf\n      affiliation\n      award\n      honorificSuffix\n      jobTitle\n      specialties\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import gql from 'graphql-tag';
import { getAuthors } from '@nerdwallet/wp-api/selectors/common';
import { NERDWALLET_AUTHOR_ID, ORGANIZATION } from '../../constants';
/*
 * Get the schema for Author
 *
 * @param  {Object} post WordPress post object
 *
 * @return {Object} Author schema
 */

export var getAuthorSchema = function getAuthorSchema(post) {
  // eslint-disable-next-line no-underscore-dangle, no-use-before-define
  if (post.__typename) return getAuthorSchemaGql(post);
  var authorSchema = {};
  var authors = getAuthors(post);
  var primaryAuthor = authors[0]; // only include the primary author

  if (primaryAuthor) {
    if (primaryAuthor.id === NERDWALLET_AUTHOR_ID) {
      // NerdWallet
      authorSchema = {
        '@id': ORGANIZATION['@id']
      };
    } else {
      authorSchema = {
        '@type': 'Person',
        image: _get(primaryAuthor, 'avatar_urls[96]'),
        name: primaryAuthor.name,
        sameAs: primaryAuthor.link,
        award: primaryAuthor.nw_user_award,
        honorificSuffix: primaryAuthor.nw_user_honorific_suffix,
        jobTitle: primaryAuthor.nw_user_job_title,
        knowsAbout: primaryAuthor.nw_user_specialties
      };

      if (primaryAuthor.nw_user_affiliation) {
        authorSchema.affiliation = {
          '@type': 'Organization',
          name: primaryAuthor.nw_user_affiliation
        };
      }

      if (primaryAuthor.nw_user_alumni_of) {
        authorSchema.alumniOf = {
          '@type': 'EducationalOrganization',
          name: primaryAuthor.nw_user_alumni_of
        };
      }
    }
  }

  return authorSchema;
};
getAuthorSchema.fragment = gql(_templateObject());
/*
 * Get the schema for a Person
 *
 * @param  {Object} person query0 person object
 *
 * @return {Object} Person schema
 */

var getPersonSchemaGql = function getPersonSchemaGql(person) {
  var _person$avatarUrls, _person$avatarUrls$;

  var personSchema = {};

  if (!person) {
    return personSchema;
  }

  if (person.id === NERDWALLET_AUTHOR_ID) {
    // NerdWallet
    return {
      '@id': ORGANIZATION['@id']
    };
  }

  personSchema = {
    '@type': 'Person',
    image: (_person$avatarUrls = person.avatarUrls) === null || _person$avatarUrls === void 0 ? void 0 : (_person$avatarUrls$ = _person$avatarUrls[0]) === null || _person$avatarUrls$ === void 0 ? void 0 : _person$avatarUrls$.url,
    name: person.name,
    sameAs: person.link,
    award: person.award,
    honorificSuffix: person.honorificSuffix,
    jobTitle: person.jobTitle,
    knowsAbout: person.specialties
  };

  if (person.affiliation) {
    personSchema.affiliation = {
      '@type': 'Organization',
      name: person.affiliation
    };
  }

  if (person.alumniOf) {
    personSchema.alumniOf = {
      '@type': 'EducationalOrganization',
      name: person.alumniOf
    };
  }

  return personSchema;
};
/*
 * Get the schema for Author
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} Author schema
 */


var getAuthorSchemaGql = function getAuthorSchemaGql(post) {
  var _ref;

  var authors = (_ref = post === null || post === void 0 ? void 0 : post.authors) !== null && _ref !== void 0 ? _ref : [];
  var primaryAuthor = authors[0]; // only include the primary author

  return getPersonSchemaGql(primaryAuthor);
};
/*
 * Get the schema for Editor
 *
 * @param  {Object} post query0 post object
 *
 * @return {Object} Editor schema
 */


export var getEditorSchema = function getEditorSchema(post) {
  var editor = post === null || post === void 0 ? void 0 : post.assigningEditor;
  return getPersonSchemaGql(editor);
};
getEditorSchema.fragment = gql(_templateObject2());
/**
 * Get about schema for categories
 *
 * @param  {Array} categories array
 *
 * @return {Array} categories with mapped schema array
 */

export var getAboutSchema = function getAboutSchema(categories) {
  // eslint-disable-next-line no-use-before-define, no-underscore-dangle
  if (categories.__typename) return getAboutSchemaGql(categories);
  return categories.map(function (category) {
    return {
      '@type': 'Thing',
      name: _get(category, 'name')
    };
  });
};
getAboutSchema.fragment = gql(_templateObject3());
/**
 * Get about schema for categories
 *
 * @param  {Object} article query0 object
 *
 * @return {Array} categories with mapped schema array
 */

var getAboutSchemaGql = function getAboutSchemaGql(article) {
  var _ref2;

  return ((_ref2 = article === null || article === void 0 ? void 0 : article.categories) !== null && _ref2 !== void 0 ? _ref2 : []).map(function (category) {
    return {
      '@type': 'Thing',
      name: category === null || category === void 0 ? void 0 : category.name
    };
  });
};